import { load, store } from "../localStorage"
import { getGA4SessionId } from "../utils"

export default (getView) => (urls) => ({
  ...getView(urls),

  handleCheckoutSubmit() {
    this.checkout.submit()
  },

  async init() {
    this.store = Alpine.store("data")
    this.displayButton = false
    this.buttonDisabled = false
    const data = load("data")

    const primer = data.values.primer

    if (new Date(primer?.expiry_date) <= new Date() || primer?.invoice?.completed_at !== null) {
      const client_session = await this.getClientSession()

      if (!client_session) return

      const expiry_date = new Date()
      expiry_date.setSeconds(expiry_date.getSeconds() + client_session.invoice.session_time_left)

      data.values.primer = {
        expiry_date: expiry_date,
        invoice: client_session.invoice,
        last_chance: false,
      }

      // save new date
      store("data", data)

      this.store.initiateCheckout(
        client_session.invoice.identifier,
        data.values.primer,
        urls.paymentSuccessUrl,
        urls.paymentFailUrl
      )
    }

    if (!data.values.primer.last_chance && data.values.exitIntent) {
      const last_chance = await this.lastChance(data.values.primer)
      if (last_chance) {
        data.values.primer.invoice.session_identifier = last_chance.data.session_identifier
        data.values.primer.last_chance = true

        store("data", data)
      } else {
        data.values.primer.invoice.completed_at = true
        return store("data", data)
      }
    }

    this.render(data)
  },

  async lastChance(primer) {
    const response = await fetch(
      `${pipelineConfig.productApiUrl}/pay/primer/invoices/${primer.invoice.id}/chance`,
      {
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
      }
    ).then((response) => response.json())

    if (!response.error) return response

    return false
  },

  async getClientSession() {
    const { userId, userToken, utm_campaign, utm_content, utm_medium, utm_source, _ga, utm_term } =
      this.store.values
    const paymode = 15

    if (!userId || !userToken) return

    return await fetch(
      `${pipelineConfig.productApiUrl}/pay/checkout/${pipelineConfig.productOfferId}/${userId}/${paymode}`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: userToken },
        body: JSON.stringify({
          initiated_remotely: true,
          external_sync: true,
          origin_path: pipelineConfig.pathPrefix,
          ga_session_id: getGA4SessionId(),
          ga_cid: _ga?.match(/[^\.]+\.[^\.]+$/)?.[0] || "",
          utm_source: `${utm_source}`,
          utm_medium: `${utm_medium}`,
          utm_campaign: `${utm_campaign}`,
          utm_term: `${utm_term}`,
          utm_content: `${utm_content}`,
        }),
      }
    ).then((response) => response.json())
  },

  async render(data) {
    const CHECKOUT_STYLE = {
      stylesheets: [
        {
          href: "https://fonts.googleapis.com/css2?family=Source+Sans+Pro&display=swap",
        },
      ],
      loadingScreen: {
        color: "#ff9e00",
      },
      formSpacings: {
        betweenInputs: "5px",
        betweenLabelAndInput: "8px",
      },
      input: {
        base: {
          paddingHorizontal: "12px",
          background: "#fff",
          fontFamily: "'Source Sans Pro', sans-serif",
          borderStyle: "solid",
          borderRadius: "3px",
          borderColor: "#f0f0f0",
          borderWidth: "1px",
          fontWeight: "normal",
          fontSize: "16px",
          lineHeight: "normal",
          letterSpacing: "0.2px",
          color: "#757575",
          placeHolder: {
            color: "rgba(64, 64, 64, 0.4)",
          },
          focus: {
            borderColor: "#ff9e00",
          },
        },
        inputLabel: {
          fontFamily: "'Source Sans Pro', sans-serif",
          fontSize: "12px",
          color: "#404040",
        },
      },
      paymentMethodButton: {
        marginTop: "24px",
      },
      processingIndicator: {
        color: "#ff9e00",
      },
      separator: {
        color: "#ff9e00",
      },
    }

    const primer = data.values.primer
    const dataStore = this.store

    this.checkout = await Primer.showUniversalCheckout(primer.invoice.session_identifier, {
      // Specify the selector of the container element
      container: "#primer-checkout-container",
      paymentHandling: "AUTO",
      submitButton: {
        useBuiltInButton: false,
        onVisible: (isVisible) => (this.displayButton = isVisible),
        onDisable: (isDisabled) => (this.buttonDisabled = isDisabled),
      },
      vault: {
        visible: false,
      },
      async onCheckoutComplete({ payment }) {
        data.values.primer.invoice.completed_at = new Date()
        store("data", data)
        await dataStore.completePayment()
        return (window.location = urls.paymentSuccessUrl)
      },
      onCheckoutFail({ payment }) {
        data.values.primer.invoice.completed_at = new Date()
        store("data", data)
        return (window.location = urls.paymentFailUrl)
      },
      googlePay: {
        captureBillingAddress: true,
      },
      style: CHECKOUT_STYLE,
    })
  },
})
